import { Link } from "react-router-dom";
import { Star, Quote } from "lucide-react";

export default function ReviewCard({ r, propertyName, propertySlug, clamp = true }) {
  return (
    <figure
      data-testid={`review-card-${r.id || r.reviewer_first_name}`}
      className="flex h-full flex-col rounded-2xl border border-forest/10 bg-white p-6 shadow-card"
    >
      <Quote size={24} className="text-gold" />
      <div className="mt-3 flex items-center gap-1 text-gold">
        {Array.from({ length: 5 }, (_, i) => (
          <Star key={i} size={14} className={i < Math.round(r.rating) ? "fill-gold" : "opacity-30"} />
        ))}
        <span className="ml-2 text-xs text-noir/60 font-sans">{r.rating?.toFixed?.(1) ?? r.rating}</span>
      </div>
      {r.title && <h4 className="font-display text-xl mt-3 leading-snug line-clamp-2">{r.title}</h4>}
      <blockquote
        className={`editorial-body mt-3 text-[1.05rem] ${clamp ? "line-clamp-6 [display:-webkit-box] [-webkit-box-orient:vertical]" : ""}`}
      >
        "{r.quote}"
      </blockquote>
      <figcaption className="mt-auto pt-5 text-xs text-noir/60">
        <span className="font-medium text-forest">{r.reviewer_first_name}</span>
        {propertyName ? (
          propertySlug ? (
            <>
              {" · "}
              <Link
                to={`/stays/${propertySlug}`}
                className="font-medium text-forest underline decoration-gold/60 decoration-1 underline-offset-2 hover:text-gold"
                data-testid={`review-property-link-${propertySlug}`}
              >
                {propertyName}
              </Link>
            </>
          ) : (
            ` · ${propertyName}`
          )
        ) : ""}
        {r.review_month_year ? ` · ${r.review_month_year}` : ""}
        {r.source_platform === "airbnb" ? " · via Airbnb" : ""}
      </figcaption>
    </figure>
  );
}
